// "Checking…" under the code boxes, "Continuing…" under the account checklist: one centred green
// line with a turning ring, so the two waits look alike. The ring stays for someone who asked
// for less motion; only the turning stops.

import React from "react";
import styled, { keyframes } from "styled-components";

const BusyLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Line role="status">
    <Ring aria-hidden="true" />
    {children}
  </Line>
);

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #0a8a60;
`;

const Ring = styled.span`
  flex: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #c8eedf;
  border-top-color: #0bb07b;
  animation: ${spin} 0.9s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default BusyLabel;
